import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../utils/api';
import Alert from '../components/Alert';
import UserModal from '../components/UserModal';
import ResetPasswordModal from '../components/ResetPasswordModal';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [alert, setAlert] = useState(null);
  const [modalUser, setModalUser] = useState(undefined); // undefined=closed, null=new, object=edit
  const [resetUser, setResetUser] = useState(null);

  function loadUsers() {
    setLoading(true);
    api
      .get('/users')
      .then((res) => setUsers(res.data.users))
      .catch(() => setError('Could not load users.'))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    loadUsers();
  }, []);

  async function handleSaveUser(form) {
    if (modalUser) {
      const res = await api.put(`/users/${modalUser.id}`, form);
      setUsers((prev) => prev.map((u) => (u.id === res.data.user.id ? res.data.user : u)));
    } else {
      const res = await api.post('/users', form);
      setUsers((prev) => [...prev, res.data.user]);
    }
    setModalUser(undefined);
    setAlert({ type: 'success', msg: 'User saved.' });
  }

  async function handleResetPassword(newPassword) {
    await api.patch(`/users/${resetUser.id}/reset-password`, { newPassword });
    setResetUser(null);
    setAlert({ type: 'success', msg: 'Password updated.' });
  }

  return (
    <Layout title="User Management">
      <Alert type={alert?.type} message={alert?.msg} onClose={() => setAlert(null)} />
      <Alert type="danger" message={error} onClose={() => setError('')} />

      <div style={{ marginBottom: '1rem' }}>
        <button className="btn btn-primary" onClick={() => setModalUser(null)}>
          <i className="ti ti-user-plus" aria-hidden="true"></i>Add User
        </button>
      </div>

      <div className="card">
        {loading ? (
          <div className="empty-state">Loading users...</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>
                    <strong style={{ fontWeight: 600 }}>{u.name}</strong>
                  </td>
                  <td style={{ fontFamily: 'monospace' }}>{u.username}</td>
                  <td>{u.phone || '-'}</td>
                  <td>
                    <span className={`badge ${u.role === 'admin' ? 'badge-blue' : 'badge-gray'}`}>
                      {u.role === 'admin' ? 'Admin' : 'Staff'}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-sm" onClick={() => setModalUser(u)}>
                      <i className="ti ti-edit" aria-hidden="true"></i>Edit
                    </button>
                    &nbsp;
                    <button className="btn btn-sm" onClick={() => setResetUser(u)}>
                      <i className="ti ti-key" aria-hidden="true"></i>Reset Password
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modalUser !== undefined && (
        <UserModal user={modalUser} onCancel={() => setModalUser(undefined)} onSave={handleSaveUser} />
      )}

      {resetUser && (
        <ResetPasswordModal user={resetUser} onCancel={() => setResetUser(null)} onConfirm={handleResetPassword} />
      )}
    </Layout>
  );
}
